<template>
    <router-view />
</template>

<script>
export default {
    name: "GiftBoxCampaignPage"
}
</script>
